import styled from 'styled-components';
import { Button, Card } from 'react-bootstrap';
import { theme } from '../../../../theme';

const { colors, filters } = theme;

export const CardFooter = styled(Card.Footer)`
  &.filter-card-footer {
    margin-bottom: 15px;
    margin-top: -5px;
    background: transparent;
    padding: 9px 0;
    border-top: 1px solid ${filters.lightGray6};
    border-bottom: 1px solid ${colors.line};
  }
`;

export const ButtonClear = styled(Button)`
  &.filter-footer-clear-btn {
    padding: 0;
    border: none;
    font-weight: 400;
    background-color: unset;
    box-shadow: none !important;
    color: ${colors.secondary};
    min-height: unset !important;

    &:hover,
    &:active,
    &:focus {
      color: ${colors.secondary} !important;
      background-color: unset !important;
      box-shadow: none !important;
    }
  }
`;
